.info-container {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid var(--color-grayscale-tuna);
}

.title {
  font-size: 1.4rem;
  font-weight: 300;
  padding: 0.8rem 0;
  color: var(--color-grayscale-white);
}

.collapsible-content {
  display: flex;
  flex-direction: column;
  padding-top: 0.8rem;
  gap: 1.2rem;

  &[data-gap='narrow'] {
    gap: 0.8rem;
  }
}

.action-item {
  display: flex;
  flex-direction: row;
  padding: 0.8rem 1.6rem;
  gap: 0.8rem;
  font-size: 1.4rem;
  font-weight: 300;
  color: var(--color-grayscale-white);
  cursor: pointer;

  &[data-type='danger'] {
    color: var(--color-error);
  }

  &[data-disabled='true'] {
    color: var(--color-grayscale-trout);
    pointer-events: none;
  }
}

.action-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  width: 1.6rem;
  height: 1.6rem;

  svg {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
  }
}
